import { Fragment, type ReactNode } from "react";
import type { PrvT } from "./usePrvTranslation";

/**
 * Render a translated sentence with its values in bold, whatever order the
 * translation puts them in: values are interpolated as markers first, then
 * the string is split around them.
 */
export function withBoldValues(
  t: PrvT,
  key: string,
  values: Record<string, string | number>
): ReactNode {
  const markers = Object.fromEntries(Object.keys(values).map((k) => [k, `\u0000${k}\u0000`]));
  const parts = t(key, markers).split("\u0000");
  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <span key={index} className="font-semibold text-gray-900">
        {values[part]}
      </span>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    )
  );
}
